export const STOCK_OPT_IN_COLUMNS = [
  { id: 'local', label: 'Local' },
  { id: 'capacidad', label: 'Capacidad' },
  { id: 'bateria', label: 'Batería' },
  { id: 'precio', label: 'Precio' },
  { id: 'descuento', label: 'Descuento' },
  { id: 'costo', label: 'Costo' },
  { id: 'color', label: 'Color' },
  { id: 'caja', label: 'Caja' },
  { id: 'imei', label: 'IMEI' },
  { id: 'serie', label: 'Serie' },
  { id: 'ingreso', label: 'Ingreso' },
  { id: 'proveedor', label: 'Proveedor' },
  { id: 'reacondicionado', label: 'Reacondicionado' },
  { id: 'observacion', label: 'Observación' },
] as const;

export type StockOptInColumnId = (typeof STOCK_OPT_IN_COLUMNS)[number]['id'];

/** toggle, Marca, Modelo, Estado, Stock, Acciones */
export const REQUIRED_COLUMN_COUNT = 6;
